export default {"src":"https://cloudflare.edhrec.com/_next/static/media/manargwu.1f530919.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};